import http from "../../services/http";

const getMunicipios = async (uf) => {
  return await http("get", `v1/municipios/listar/${uf}`, []);
};

export { getMunicipios };
